/**
 * Contacts page APIs.
 */
import { apihubUpload } from "./apihub";
import {
  fetchAllannouncement,
  fetchAllnotification,
  fetchFetchedallplans,
  fetchFetchedallurgentannouncementById,
  fetchFetchedcurrentlogo,
  fetchFetchtagsbyprojectidById,
  fetchGetattributesdetailByPhoneNoId,
  fetchGetInteractedCustomersByBusinessIdPaginatedByPhoneNoId,
  fetchGetTeamOfProjectById,
  fetchGetusernameofmainbusinessnull,
  fetchProfile,
  fetchProjectsById,
  patchUpdateroundrobinByProjectId,
} from "./customer.api";
import { fetchTotalRemainingQuota } from "./quota";

export function loadAppShell({ projectId, phoneNoId } = {}) {
  const tasks = [
    fetchAllannouncement(),
    fetchAllnotification(),
    fetchFetchedcurrentlogo(),
    fetchFetchedallplans(),
    fetchGetusernameofmainbusinessnull(),
    fetchProfile(),
  ];
  if (projectId) {
    tasks.push(
      fetchFetchedallurgentannouncementById({ id: projectId }),
      fetchProjectsById({ id: projectId }),
      fetchGetTeamOfProjectById({ id: projectId }),
      fetchFetchtagsbyprojectidById({ id: projectId }),
    );
  }
  if (phoneNoId) {
    tasks.push(fetchGetattributesdetailByPhoneNoId({ phoneNoId }));
  }
  return Promise.all(tasks);
}

export function fetchContactsPaginated(
  phoneNoId,
  { page = 1, limit = 100, search = "" } = {},
) {
  return fetchGetInteractedCustomersByBusinessIdPaginatedByPhoneNoId(
    { phoneNoId },
    { page, limit, search },
  );
}

export function fetchRemainingQuota(phoneNoId) {
  return fetchTotalRemainingQuota(phoneNoId);
}

export function updateRoundRobin(projectId, value) {
  return patchUpdateroundrobinByProjectId({ projectId }, { value });
}

export function uploadContactsCsv({
  csvFile,
  mappings,
  phoneNoId,
  wabaId,
  countryCode,
  projectId,
}) {
  const form = new FormData();
  form.append("csvFile", csvFile);
  form.append("mappings", JSON.stringify(mappings));
  form.append("phone_number_id", phoneNoId);
  if (wabaId) form.append("waba_id", wabaId);
  form.append("country_code", countryCode);
  form.append("projectId", projectId);
  return apihubUpload("/getInteractedCustomerDetail/uploadcsvcontact", form);
}
